import { Form, Row, Col, Alert } from "react-bootstrap";
import Footer from "../../Components/common/Footer";
import Header from "../../Components/common/Header";
import LoginImg from "../../Imge/undraw_login_weas.svg";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { baseURL, RESETPASSWORD } from "../../API/API";
import Lodingsubmit from "../../Components/Loding/Loding";
import { useLocation } from "react-router-dom"; //1/ ✅ استيراد

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const location = useLocation(); //1/ ✅ استخدم useLocation

  const id = new URLSearchParams(location.search).get("id");
  const code = new URLSearchParams(location.search).get("code");

  //1/ تغيير كلمة المرور
  function handlePasswordChange(e) {
    setPassword(e.target.value);
  }

  //1/ تغيير تأكيد كلمة المرور
  function handleConfirmPasswordChange(e) {
    setConfirmPassword(e.target.value);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setErr("");
    setSuccess("");
    setPasswordError("");

    if (password !== confirmPassword) {
      setPasswordError("كلمتا المرور غير متطابقتين");
      setLoading(false);
      return;
    }

    try {
      const res = await axios.post(`${baseURL}/${RESETPASSWORD}`, {
        uidb64: id,
        password: password,
        token: code,
      });
      setSuccess(res.data.message);

      setTimeout(() => {
        window.location.href = "/login";
      }, 1500);
    } catch (err) {
      setErr(err.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading && <Lodingsubmit />}
      <div className="Authpage">
        <Header />
        <Row className="w-100">
          {/* الصورة على اليسار */}
          <Col md={4} className="imgform d-none d-md-block p-0">
            <img
              src={LoginImg}
              alt="صورة تسجيل"
              className="img-fluid h-100 w-100"
              style={{ objectFit: "cover" }}
            />
          </Col>

          {/* الفورم على اليمين */}
          <Col
            xs={12}
            md={8}
            className="form-contant d-flex align-items-center justify-content-center bg-light"
          >
            <Form className="Form w-75" onSubmit={handleSubmit}>
              <h3 className="titleForm mb-4 ">إعادة تعيين كلمة المرور</h3>
              <p className="mb-4">أدخل كلمة المرور الجديدة</p>

              {/* كلمة المرور الجديدة */}
              <Form.Group className="floating-label-group mb-4 w-100">
                <Form.Control
                  placeholder=" "
                  required
                  className="inpoutFeald"
                  type="password"
                  name="password"
                  value={password}
                  onChange={handlePasswordChange}
                />
                <Form.Label>
                  <FontAwesomeIcon className="iconeForm" icon={faLock} />
                  <span className="textinpout">كلمة المرور الجديدة</span>
                </Form.Label>
              </Form.Group>

              {/* تأكيد كلمة المرور */}
              <Form.Group className="floating-label-group mb-4 w-100">
                <Form.Control
                  placeholder=" "
                  required
                  className="inpoutFeald"
                  type="password"
                  name="confirmPassword"
                  value={confirmPassword}
                  onChange={handleConfirmPasswordChange}
                />
                <Form.Label>
                  <FontAwesomeIcon className="iconeForm" icon={faLock} />
                  <span className="textinpout">تأكيد كلمة المرور</span>
                </Form.Label>
                {passwordError && (
                  <div
                    className="invalid-feedback d-block"
                    style={{ color: "#dc3545", fontSize: "0.9rem" }}
                  >
                    {passwordError}
                  </div>
                )}
              </Form.Group>

              {/* زر الإرسال */}
              <button type="submit" className="btn_submit btn_small ms-auto">
                {loading ? "جاري إعادة التعيين..." : "إعادة التعيين"}
              </button>

              {/* رسائل النجاح والخطأ */}
              {err && (
                <Alert variant="danger" style={{ marginTop: "20px" }}>
                  ❌ {err}
                </Alert>
              )}
              {success && (
                <Alert variant="success" style={{ marginTop: "20px" }}>
                  ✅ {success}
                </Alert>
              )}

              <Link
                to="#"
                target="_blank"
                className="btn_square_green mt-3 d-block"
              >
                طريقة إنشاء حساب على نوح أكاديمي
              </Link>

              <div className="mt-4">
                لا يوجد لديك حساب؟{" "}
                <Link to="/register" className="text-decoration-none">
                  <span className="gold">أنشئ حسابك الآن!</span>
                </Link>
              </div>
            </Form>
          </Col>
        </Row>
        <Footer />
      </div>
    </>
  );
}
